/**
 * SSL ID: вход через id.skillslab.center для курсов с `sso_enabled`.
 *
 * Сессия живёт в HttpOnly-cookie `ssl_session` на `.skillslab.center`. courses-creator
 * пока проверяет только `Authorization: Bearer`, поэтому cookie обменивается на токен
 * (POST /api/auth/sso/token/), который дальше хранится как обычный `access_token`.
 * Как в exercises_web; план перехода на чистые cookie —
 * users_service/docs/sso-cookie-migration.md.
 */

const trimSlash = (url: string) => url.replace(/\/$/, "");

export const USERS_API_URL = trimSlash(
  import.meta.env.VITE_USERS_API_URL || "https://api.users.skillslab.center"
);
const SSL_ID_URL = trimSlash(
  import.meta.env.VITE_SSL_ID_URL || "https://id.skillslab.center"
);

/** Обменивает cookie-сессию на токен; null — сессии нет или users_service недоступен. */
export const exchangeSsoToken = async (): Promise<string | null> => {
  try {
    const response = await fetch(`${USERS_API_URL}/api/auth/sso/token/`, {
      method: "POST",
      credentials: "include",
    });
    if (response.status !== 200) return null;
    const data = (await response.json()) as { token?: string };
    return data.token || null;
  } catch {
    // сеть недоступна — считаем, что сессии нет
    return null;
  }
};

/** Уводит на id.skillslab.center; после входа id вернёт пользователя на returnPath этого курса. */
export const redirectToSslId = (returnPath = "/") => {
  const returnUrl = `${window.location.origin}${returnPath}`;
  const params = new URLSearchParams({ return_url: returnUrl });
  window.location.assign(`${SSL_ID_URL}/?${params.toString()}`);
};

/** Завершает SSO-сессию (для всех сервисов сразу). Ошибки не мешают локальному выходу. */
export const ssoLogout = async () => {
  try {
    await fetch(`${USERS_API_URL}/api/auth/sso/logout/`, {
      method: "POST",
      credentials: "include",
    });
  } catch {
    // ignore
  }
};
